module.exports = __webpack_public_path__ + "img/logo-light.2d45f5a1.svg";